<vi-page [sidenavs]="true" [footer]="true">
  <app-downtime-notification head></app-downtime-notification>
  <app-callback-notification head></app-callback-notification>

  <vi-content
    body
    data-at-gateway-commissioning-active-step
    direction="row"
    [wrap]="true"
    layoutAlign="justify-between items-start"
    gap="0px"
  >
    <div main>
      <ng-container *ngIf="gatewayCommissioningStore.activeStep$ | async as activeStep">
        <ng-container *ngIf="activeStep === step.SELECT_INSTALLATION_TYPE">
          <div class="flex flex-col gap-[24px] flex-[100%] max-w-[100%]">
            <span class="commissioning-title flex-auto" data-at-gateway-commissioning-title>
              {{ '+GATEWAY_COMMISSIONING.TYPE_SELECTION_HEADER' | translate }}
            </span>
            <span
              class="commissioning-description flex-auto"
              data-at-gateway-commissioning-description
            >
              {{ '+GATEWAY_COMMISSIONING.TYPE_SELECTION_DESCRIPTION' | translate }}
            </span>
            <app-installation-type-select></app-installation-type-select>
          </div>
        </ng-container>

        <app-commissioning-steps
          *ngIf="activeStep !== step.SELECT_INSTALLATION_TYPE"
          [activeStep]="activeStep"
        ></app-commissioning-steps>
      </ng-container>
    </div>
  </vi-content>

  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>
